namespace GeniuzPOS.InventoryReport {
    export interface IcReport05Row {
        Id?: string;
        SkuCode?: string;
        SkuDesc?: string;
        CatCode?: string;
        CatName?: string;
        SubCat1Code?: string;
        SubCat1Name?: string;
        SubCat2Code?: string;
        SubCat2Name?: string;
        BrandCode?: string;
        BrandName?: string;
        StyleId?: string;
        StyleName?: string;
        ColorId?: string;
        ColorName?: string;
        SizeId?: string;
        SizeName?: string;
        TasteId?: string;
        TasteName?: string;
        MatTypeId?: string;
        MatTypeName?: string;
        SupplId?: string;
        SupplName?: string;
        StockFg?: number;
        ConsignFg?: number;
        WhsId?: string;
        WhsName?: string;
        WhsType?: number;
        ShopId?: string;
        ShopTypeId?: string;
        ShopTypeName?: string;
        ShopGroupId?: string;
        ShopGroupName?: string;
        ShopName?: string;
        GroupType?: string;
        EomIn?: number;
        IcReceive?: number;
        IcReturnOut?: number;
        IcSold?: number;
        IcReturnIn?: number;
        IcAdjIn?: number;
        IcAdjOut?: number;
        IcTranIn?: number;
        IcTranOut?: number;
        SumOut?: number;
        DateMonth?: string;
        DateYear?: string;
    }

    export namespace IcReport05Row {
        export const idProperty = 'Id';
        export const nameProperty = 'SkuCode';
        export const localTextPrefix = 'InventoryReport.IcReport05';
        export const deletePermission = '2Inventory:รายงาน:มูลค่า:View';
        export const insertPermission = '2Inventory:รายงาน:มูลค่า:View';
        export const readPermission = '2Inventory:รายงาน:มูลค่า:View';
        export const updatePermission = '2Inventory:รายงาน:มูลค่า:View';

        export declare const enum Fields {
            Id = "Id",
            SkuCode = "SkuCode",
            SkuDesc = "SkuDesc",
            CatCode = "CatCode",
            CatName = "CatName",
            SubCat1Code = "SubCat1Code",
            SubCat1Name = "SubCat1Name",
            SubCat2Code = "SubCat2Code",
            SubCat2Name = "SubCat2Name",
            BrandCode = "BrandCode",
            BrandName = "BrandName",
            StyleId = "StyleId",
            StyleName = "StyleName",
            ColorId = "ColorId",
            ColorName = "ColorName",
            SizeId = "SizeId",
            SizeName = "SizeName",
            TasteId = "TasteId",
            TasteName = "TasteName",
            MatTypeId = "MatTypeId",
            MatTypeName = "MatTypeName",
            SupplId = "SupplId",
            SupplName = "SupplName",
            StockFg = "StockFg",
            ConsignFg = "ConsignFg",
            WhsId = "WhsId",
            WhsName = "WhsName",
            WhsType = "WhsType",
            ShopId = "ShopId",
            ShopTypeId = "ShopTypeId",
            ShopTypeName = "ShopTypeName",
            ShopGroupId = "ShopGroupId",
            ShopGroupName = "ShopGroupName",
            ShopName = "ShopName",
            GroupType = "GroupType",
            EomIn = "EomIn",
            IcReceive = "IcReceive",
            IcReturnOut = "IcReturnOut",
            IcSold = "IcSold",
            IcReturnIn = "IcReturnIn",
            IcAdjIn = "IcAdjIn",
            IcAdjOut = "IcAdjOut",
            IcTranIn = "IcTranIn",
            IcTranOut = "IcTranOut",
            SumOut = "SumOut",
            DateMonth = "DateMonth",
            DateYear = "DateYear"
        }
    }
}
